import { render, staticRenderFns } from "./EmojiKeyboard.vue?vue&type=template&id=45795bf0&scoped=true&"
import script from "./EmojiKeyboard.vue?vue&type=script&lang=js&"
export * from "./EmojiKeyboard.vue?vue&type=script&lang=js&"
import style0 from "./EmojiKeyboard.vue?vue&type=style&index=0&id=45795bf0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45795bf0",
  null
  
)

export default component.exports